const CheckedTicketIcon = () => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="32" height="32" rx="4" fill="#FFFBEB" />
      <path
        d="M19.8297 23.2492L17.7923 23.7886C15.9066 24.2878 14.9637 24.5374 14.2249 24.1286C13.4861 23.7197 13.24 22.8121 12.7476 20.9967L11.5293 16.5041C11.037 14.6887 10.7908 13.7811 11.2237 13.0621C11.6566 12.343 12.5995 12.0934 14.4853 11.5942L17.8189 10.7116C19.7047 10.2124 20.6476 9.96274 21.3864 10.3716C22.1252 10.7804 22.3713 11.6881 22.8636 13.5034L24.0868 18.0139C24.2962 18.7859 24.4009 19.1719 24.2858 19.5348M19.8297 23.2492C20.4564 23.0832 20.4614 23.0806 20.9488 22.6624L23.2353 20.7004C23.859 20.1653 24.1708 19.8977 24.2858 19.5348M19.8297 23.2492C19.8297 23.2492 20.3197 19.4216 21.4167 18.9167C22.661 18.3441 24.2858 19.5348 24.2858 19.5348"
        stroke="#FFC700"
        stroke-width="1.25"
        stroke-linejoin="round"
      />
      <path
        d="M20.1665 10.1677C20.1128 9.27324 19.9643 8.71017 19.5402 8.30643C18.8906 7.68803 17.8482 7.68495 15.7632 7.67878L12.0775 7.66789C9.99258 7.66173 8.95011 7.65865 8.30429 8.27323C7.65848 8.8878 7.66152 9.88002 7.6676 11.8645L7.68265 16.7757C7.68874 18.7602 7.69178 19.7523 8.34137 20.3708C8.99096 20.9892 10.0334 20.9923 12.1184 20.9984L12.6857 21.0001"
        stroke="#FFC700"
        stroke-width="1.5"
      />
    </svg>
  );
};

export default CheckedTicketIcon;
